import { Link } from '@inertiajs/inertia-react';
import useLazyLoad from 'app/components/hooks/useLazyLoad';
import usePageProps from 'app/components/hooks/usePageProps';
import Icon from 'app/components/Icon';
import Layout from 'app/components/Layouts/Layout'
import { MODALS, ModalsContext } from 'app/components/Layouts/Modals';
import { ProjectType } from 'app/components/Types/ProjectType';
import { UserType } from 'app/components/Types/UserType';
import IconText from 'app/fragments/IconText';
import { LineButton } from 'app/fragments/LineButton';
import { ProjectCard } from 'app/fragments/ProjectCard';
import React, { useContext } from 'react'
import route from 'ziggy-js';

interface Props {

}

function Projects(props: Props) {
    const { } = props

    const [projects, button, meta, form, setProjects] = useLazyLoad<ProjectType>('projects');
    let { open } = useContext(ModalsContext)
    const { user } = usePageProps<{ user: UserType }>();

    return (
        <Layout className='text-white' heading="My Projects">
            <div className="flex justify-between mt-40px">
                {/* <h2 className="text-24 font-bold">Ahoj {user.name},</h2> */}
                <div></div>
                <div>
                    <div></div>
                    <a className="cursor-pointer" onClick={() => open(MODALS.NEWPROJECT)}><IconText className="bg-green-539648 text-white py-12px px-16px rounded-full text-16 font-medium" icon="plus" text="Add Project" /></a>
                </div>
            </div>
            <div className="grid grid-cols-3 gap-30px mt-60px mob:grid-cols-1">
                {
                    projects.map(p =>
                        <ProjectCard p={p} />

                    )
                }
            </div>
            {button && <LineButton {...button} text={`Show more (${meta.next})`} href={"#"} disabled={meta.total == meta.to} showing={{max: meta.total, current: meta.to}} />}
            {/* {
                meta &&
                <div className="flex justify-center my-20px">
                    <div className="text-white text-16">Zobrazuji {meta.to} z {meta.total}</div>
                </div>
            } */}
        </Layout>
    )
}

export default Projects
